import React, { useContext, useState } from "react";
import { SetdataContext } from "../context/SetdataContext";

function FormResume() {

    const {loadResume} = useContext(SetdataContext)
    
    const [campo, setCampo] = useState({
        lang: "",
        section: "",
        object: {
            title: "",
            location: "",
            date: "",
            details: ""
        }
        
    })

    const [curso, setCurso] = useState({
        lang: "",
        section: "",
        object: {
            name: "",
            location: "",
            date: "",
            details: ""
        }
    })

    const [idioma, setIdioma] = useState({
        lang: "",
        section: "",
        object: {
            language: ""
        }
    })

    const [habilidades, setHabilidades] = useState({
        lang: "",
        section: "",
        object: {
            skill: ""
        }
    })

    const [otros, setOtros] = useState({
        lang: "",
        section: "other",
        object: {
            knowledge: ""
        }
    })

    const changCampo = (e) => {
        let auxObj = {...campo}
        
        switch (e.target.name) {
            case "lang":
                auxObj.lang = e.target.value
                break;

            case "section":
                auxObj.section = e.target.value
                break;
        
            default:
                auxObj.object[e.target.name] = e.target.value
                break;
        }        
        setCampo({
            ...auxObj
        })
    }

    const changeCurso = (e) => {
        let auxObj = {...curso}
        
        switch (e.target.name) {
            case "lang":
                auxObj.lang = e.target.value
                break;

            case "section":
                auxObj.section = e.target.value
                break;
        
            default:
                auxObj.object[e.target.name] = e.target.value
                break;
        }

        setCurso({
            ...auxObj
        })
    }

    const changeLang = (e) => {
        let auxObj = {...idioma}

        if(auxObj.lang === "ingles"){
            auxObj.section = "Languages"
        } else if (auxObj.lang === "español"){
            auxObj.section = "Idiomas"
        }
        
        if(e.target.name === "lang"){
            auxObj.lang = e.target.value
        } else {
            auxObj.object[e.target.name] = e.target.value
        }  
        
        setIdioma({
            ...auxObj
        })
    }

    const changeSkill = (e) => {
        let auxObj = {...habilidades}
        
        switch (e.target.name) {
            case "lang":
                auxObj.lang = e.target.value
                break;

            case "section":
                auxObj.section = e.target.value
                break;
        
            default:
                auxObj.object[e.target.name] = e.target.value
                break;
        }        

        setHabilidades({
            ...auxObj
        })
    }

    const changeOthers = (e) => {
        let auxObj = {...otros}
        
        switch (e.target.name) {
            case "lang":
                auxObj.lang = e.target.value
                break;
        
            default:
                auxObj.object[e.target.name] = e.target.value
                break;
        }        
        
        if(auxObj.lang === "ingles"){
            auxObj.section = "Others Knowledge"
        } else if(auxObj.lang === "español"){
            auxObj.section = "Otros Conocimientos"
        }

        setOtros({
            ...auxObj
        })
    }

    const sub = (objetStr) => {
        switch (objetStr) {
            case "campo":
                loadResume(campo)
                break;

            case "curso":
                loadResume(curso)
                break;

            case "idioma":
                loadResume(idioma)
                break;

            case "habilidades":
                loadResume(habilidades)
                break;

            case "otros":
                loadResume(otros)
                break;
        
            default:
                break;
        }        
    }

    return(
        <div className="setResume">
            <form>
                <fieldset>
                    <legend>. Experiencia Laboral / Educacion .</legend>
                    <div className="language">
                        <label htmlFor="lang">Idioma: </label>
                        <select name="lang" onChange={changCampo}>
                            <option></option>
                            <option value="ingles">Ingles</option>
                            <option value="español">Español</option>
                        </select>
                    </div>

                    <div className="setResume__campo">
                        <label htmlFor="section">Campo:</label>
                        <select className="setResume__campo" name="section" onChange={changCampo}>
                            <option></option>
                            <option value={campo.lang === "ingles" ? "Education" : "Educación"}>Educacion</option>
                            <option value={campo.lang === "ingles" ? "Work Experience" : "Experiencia Laboral"}>Experiencia Laboral</option>
                        </select>
                    </div>

                    <div className="setResume__campoData">
                        <label htmlFor="title">Titulo/Puesto: </label>
                        <input type="text" name="title" onChange={changCampo} />

                        <label htmlFor="location">Lugar: </label>
                        <input type="text" name="location" onChange={changCampo} />

                        <label htmlFor="date">Fecha: </label>
                        <input type="text" name="date" onChange={changCampo} />

                        <label htmlFor="details">Detalle: </label>
                        <textarea name="details" onChange={changCampo} />
                    </div>

                    <button type="button" onClick={() => sub("campo")}>AGREGAR</button>
                </fieldset>                
            </form>

            <form>
                <fieldset>
                    <legend>. Cursos .</legend>

                    <div className="language">
                        <label htmlFor="lang">Idioma: </label>
                        <select name="lang" onChange={changeCurso}>
                            <option></option>
                            <option value="ingles">Ingles</option>
                            <option value="español">Español</option>
                        </select>
                    </div>

                    <div className="setResume__courses">
                        <label htmlFor="section">Cursos</label>
                        <select className="setResume__course" name="section" onChange={changeCurso} >
                            <option></option>
                            <option value={curso.lang === "ingles" ? "Courses" : "Cursos"}>Programacion</option>
                            <option value={curso.lang === "ingles" ? "Other Courses" : "Otros Cursos"}>Otros</option>
                        </select>
                    </div>

                    <div className="setResume__campoData">
                        <label htmlFor="name">Nombre: </label>
                        <input name="name" onChange={changeCurso} />

                        <label htmlFor="location">Lugar: </label>
                        <input name="location" onChange={changeCurso} />

                        <label htmlFor="date">Fecha: </label>
                        <input type="text" name="date" onChange={changeCurso} />

                        <label htmlFor="details">Descripcion: </label>
                        <textarea name="details" onChange={changeCurso} />
                    </div>

                    <button type="button" onClick={() => sub("curso")}>AGREGAR</button>
                </fieldset>                
            </form>

            <form>
                <fieldset>
                    <legend>. Idiomas .</legend>
                    <div className="language">
                        <label htmlFor="lang">Idioma: </label>
                        <select name="lang" onChange={changeLang}>
                            <option></option>
                            <option value="ingles">Ingles</option>
                            <option value="español">Español</option>
                        </select>
                    </div>

                    <div className="setResume__language">
                        <label htmlFor="language">Idiomas:</label>
                        <input type="text" name="language" onChange={changeLang}/>
                    </div>

                    <button type="button" onClick={() => sub("idioma")}>AGREGAR</button>
                </fieldset>                
            </form>

            <form>
                <fieldset>
                    <legend>. Habilidades .</legend>
                    <div className="language">
                        <label htmlFor="lang">Idioma: </label>
                        <select name="lang" onChange={changeSkill}>
                            <option></option>
                            <option value="ingles">Ingles</option>
                            <option value="español">Español</option>
                        </select>
                    </div>

                    <div className="setResume__skills">
                        <label htmlFor="section">Tipo: </label>
                        <select name="section" onChange={changeSkill}>
                            <option></option>
                            <option value={habilidades.lang === "ingles" ? "Soft Skills" : "Habilidades Blandas"}>Blandas</option>
                            <option value={habilidades.lang === "ingles" ? "Hard Skills" : "Habilidades Duras"}>Duras</option>
                        </select>
                        <label htmlFor="skill">Habilidad: </label>
                        <input type="text" name="skill" onChange={changeSkill} />
                    </div>

                    <button type="button" onClick={() => sub("habilidades")}>AGREGAR</button>
                </fieldset>                
            </form>

            <form>
                <fieldset>
                    <legend>. Otros conocimientos .</legend>
                    <div className="language">
                        <label htmlFor="lang">Idioma: </label>
                        <select name="lang" onChange={changeOthers}>
                            <option></option>
                            <option value="ingles">Ingles</option>
                            <option value="español">Español</option>
                        </select>
                    </div>

                    <div className="setResume__others">
                        <label htmlFor="knowledge">Otros Conocimientos: </label>
                        <input type="text" name="knowledge" onChange={changeOthers}/>
                    </div>
                    <button type="button" onClick={() => sub("otros")}>AGREGAR</button>
                </fieldset>                
            </form>
        </div>
    )
}

export default FormResume